import { render, staticRenderFns } from "./BsIcon.vue?vue&type=template&id=013c2ef0&"
import script from "./BsIcon.vue?vue&type=script&lang=js&"
export * from "./BsIcon.vue?vue&type=script&lang=js&"
import style0 from "./BsIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports